/* eslint-disable no-continue */
import { Settings } from '@ant-design/pro-layout';
import { Route as ProRouteType } from '@ant-design/pro-layout/es/typings';
import { action, computed, observable, runInAction, makeAutoObservable } from 'mobx';
import { history } from '../App';
import { processMenuItem, ProMenuExport, ProMenuType } from '../menu';
import PandectPage from '../pages/Pandect';
import HomePage from '../pages/Home';
import SkinPage from '../pages/Skin';
import { CurrentUser, fetchCurrentUser } from '../services/login';
import { fetchGlobalInfo, fetchPluginList, getPluginRootPath } from '../services/plugins';
// import {SortedMenu} from '../../public/SortedMenu'

type LayoutSettings = Omit<Settings, 'menu' | 'title' | 'iconfontUrl'>;

class Global {
  @observable
  loadingCurrentUser = true;


  @observable
  systemTitle = "";

  @observable
  currentUser?: CurrentUser;

  @observable
  userMenus?: any = [];

  cachedData: any = {}

  @observable
  layoutSettings: LayoutSettings = {
    navTheme: 'dark',
    layout: 'sidemenu',
    contentWidth: 'Fluid',
    fixedHeader: false,
    // @ts-ignore
    autoHideHeader: false,
    fixSiderbar: false,
  };

  plugins = observable.array<ProMenuExport>([], { deep: false });
  devPlugins = observable.array<ProMenuExport>([], { deep: false });

  t_sorted_menu: any = [];

  constructor() {
    makeAutoObservable(this);
    const layoutSettings = localStorage.getItem('layoutSettings');
    if (layoutSettings) this.layoutSettings = JSON.parse(layoutSettings);

    /* global __webpack_modules__, __webpack_require__ */
    if (process.env.MODULE_DEV) {
      // @ts-ignore
      if (__webpack_modules__['./src/index.tsx']) {
        // @ts-ignore
        this.devPlugins.push(__webpack_require__('./src/index.tsx').default);
      }
      // @ts-ignore
      else if (__webpack_modules__['./src/index.ts'])
        // @ts-ignore
        this.devPlugins.push(__webpack_require__('./src/index.ts').default);
    }
  }

  @action
  fetchCurrentUser = () => {
    this.loadingCurrentUser = true;
    fetchCurrentUser().then(
      ({ data }) => {
        runInAction(() => {
          this.loadingCurrentUser = false;
          this.currentUser = data;
        });
      },
      () => {
        history.push('/login');
      },
    );
  };

  @action
  changeSetting = <T extends keyof LayoutSettings>(
    key: T,
    value: LayoutSettings[T],
  ) => {
    this.layoutSettings[key] = value;
    localStorage.setItem('layoutSettings', JSON.stringify(this.layoutSettings));
  };

  checkMenuAuthority = (menu: ProRouteType[]) => {
    let authorities: string[] = [];
    if (this.currentUser) authorities = this.currentUser.percode_list;
    const result = [];
    for (const item of menu) {
      if (
        typeof item.authority === 'string' &&
        !authorities.includes(item.authority)
      ) {
        continue;
      }
      const newItem = { ...item };
      if (item.routes) {
        const checkedChildren = this.checkMenuAuthority(item.routes);
        if (checkedChildren.length !== 0) newItem.routes = checkedChildren;
        else continue;
      }
      result.push(newItem);
    }
    return result;
  };

  @computed
  get menu(): ProMenuType[] {
    // console.log(this.plugins, "vvvv");

    //在此排序和组装
    let plugins = [
      // PandectPage,
      HomePage,
      ...this.devPlugins.flat(),
      ...this.plugins.flat(),
      SkinPage,
    ]

    let sorted_item = this.t_sorted_menu;
    console.log(sorted_item, 'sorted_item');


    // let sorted_item = [
    //   {
    //     name: "首页1", src_path: "/"
    //   },
    //   {
    //     name: "实体管理", src_path: "entities/*"
    //   },
    //   {
    //     name: "本体管理", src_path: "/concept_manage"
    //   },
    //   // {
    //   //   name: "实体管理1", path: 'entities/*', children: [
    //   //     { path: 'entities/*', include_child: false }
    //   //   ]
    //   // },
    //   // {
    //   //   name: "系统管理", path: "/system", children: [
    //   //     { path: '/concept_manage', include_child: true },
    //   //     { path: 'admin-manage/*', include_child: true },
    //   //   ]
    //   // }
    // ]

    let findPlugin = (path: String) => {
      for (let i = 0; i < plugins.length; i++) {
        let plugin: any = plugins[i];

        if (plugin.path === path) {
          plugin.visited = true;
          return plugin;
        }
      }
      return null;
    }

    let result: any[] = []
    sorted_item.map((k: any) => {
      if (k.src_path != undefined) {
        let plugin = findPlugin(k.src_path);
        if (plugin != null) {
          if (k.name) plugin.name = k.name;
          console.log(plugin, "sss");
          result.push(plugin);
        }
        return;
      }


      let routes: any[] = [];
      if (k.children && k.children.length > 0) {
        k.children.map((child: any) => {
          let plugin = findPlugin(child.path);
          if (plugin) {
            console.log(child.include_child);

            if (child.include_child == true) {
              routes.push(...plugin.routes);
            }
            else {
              routes.push(plugin);
            }
          }
        });
      }

      let item: any = {
        name: k.name,
        path: k.path,
      };

      if (routes.length > 0)
        item["routes"] = routes;

      console.log(item, "222");
      result.push(item);
    });

    plugins.map((item: any) => {
      if (item.visited) return;
      result.push(item);
    });

    // @ts-ignore
    return result;
  }
  @computed
  get routes() {
    return this.menu.map(processMenuItem);
  }

  fetchGlobalInfo() {
    fetchGlobalInfo().then(({ data }) => {
      this.systemTitle = data.title;
    });
  }


  fetchModules() {
    console.log("fetchModules");
    // if (process.env.NODE_ENV !== 'production')
    //   return;
    fetchPluginList().then(({ data }) => {
      this.plugins.clear();
      if (data.items == undefined) data.items = [];
      this.t_sorted_menu.clear();
      if (data.sorted_menu != undefined)
        this.t_sorted_menu.push(...data.sorted_menu);

      this.systemTitle = data.title;

      // data.items.push({ plugin_id: 1, plugin_name: "插件管理", plugin_key: "plugin-admin-web", enable_status: "enable", description: "" });
      data.items
        .filter(item => item.enable_status === 'enable')
        .forEach(item => {
          let publicPath = getPluginRootPath(item.plugin_key);
          if (item?.build_time && item.build_time > 0)
            publicPath = `/_plugins/${item.plugin_key}-${item.build_time}/`
          const path = publicPath + 'static/js/main.no-cache.js';
          window.requirejs.config({
            config: { [path]: { publicPath } },
          });

          window.requirejs([path], (m: { default: ProMenuExport }) => {
            if (m?.default) {
              this.plugins.push(m.default);
            }
          });
        });
    });
  }
}

export default Global;
